import { generatePath } from 'react-router-dom'
import { REPUTATION_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Star, StarFilled } from 'blaze-ui/icons/20'
import { Pill } from 'components/Pill/Pill'
import Styles from '../NavMenu.module.scss'

interface Props {
  workspaceId: number
  onPress: () => void
}

export const NavMenuReputationItem = ({ workspaceId, onPress }: Props) => {
  const to = generatePath(REPUTATION_PATH, { workspaceId })

  return (
    <NavMenuItem icon={Star} activeIcon={StarFilled} to={to} onPress={onPress} label="Reputation">
      <Pill className={Styles.betaPill} size="sm">
        Beta
      </Pill>
    </NavMenuItem>
  )
}
